/* global mo, bases_search, map, ymaps, main, region, base */

$(function(){
    $(document).on('click', 'span.map_popup_gallery_prev, span.map_popup_gallery_next', function(){

        var popup_container = $(this).parent(),
            popup_gallery = popup_container.find('.gallery'),
            active = popup_container.find('.gallery.active'),
            image = popup_container.find('span.image'),
            direction = $(this).hasClass('map_popup_gallery_prev') ? -1 : 1;

        if(active.length === 0){

            active = popup_gallery.eq(direction === -1 ? popup_gallery.length - 1 : 0).addClass('active');
            if(!image.data('main-pic')) image.data('main-pic', image.css('background-image'));
            image.css('background-image', active.css('background-image'));

        }
        else{

            active = direction === -1 ? active.removeClass('active').prev() : active.removeClass('active').next();

            if(active.hasClass('gallery')){

                active.addClass('active');
                image.css('background-image', active.css('background-image'));
            }
            else{
                image.css('background-image', image.data('main-pic'));
            }

        }
    });
});

bases_search.map = false;
bases_search.clusterer = false;

// API карт Яндекс готово к работе
bases_search.map_init = function(){
    $map = $('#type_view_1');
    if($map.filter(':visible').length) {
        setTimeout(function() {
            $('#filter_wrapper').find('a.go').click(); // подгрузить данные карты
        });
    }
};

// вставить карту на страницу
bases_search.map_insert = function(){
    var $map = $('#type_view_1');
    if(!$map.length) return;

    if(bases_search.map) return; // карта уже загружена
    bases_search.map = true;

    var h = $(window).height() - 200;
    if(h > 1000) h = 1000;
    if(helper.isMobile()) h = 250;
    $map.css({'min-height': h});

    // if(!helper.isMobile()){
        bases_search.map = map.insert('type_view_1', {behaviors: ['drag', 'multiTouch', 'scrollZoom']});
    // }
    /*else{
        bases_search.map = map.insert('type_view_1', {behaviors: ['multiTouch', 'scrollZoom']});
    }*/
    bases_search.clusterer = map.clusterer();
    bases_search.map.geoObjects.add(bases_search.clusterer);
};

bases_search.insert_results_map = function(result){
    var map;
    var clusterer;
    var after = function(){
    };
    var auto_zoom = true;

    switch(1){
        // карта на главной
        case $('#main_map').length:
            if(result.length)
                $('#main_map').show();
            else
                $('#main_map').hide();
            main_page.map_insert();
            map = main_page.map;
            clusterer = main_page.clusterer;

            auto_zoom = false;

            break;
        // карта на странице региона
        case $('#region_map').length:
            if(!$('#map_big:visible').length){
                // маленькая
                if(result.length)
                    $('#region_map').show();
                else
                    $('#region_map').hide();

                region.map_insert();
                map = region.map;
                clusterer = region.clusterer;
            }else{
                // большая
                region.map_big_insert();
                map = region.map_big;
                clusterer = region.clusterer_big;

                after = region.map_big_after_insert;
            }

            break;
        // карта на странице курорта
        case $('#resort_map').length:
            if(!$('#map_big:visible').length){
                // маленькая
                if(result.length)
                    $('#resort_map').show();
                else
                    $('#resort_map').hide();

                resort.map_insert();
                map = resort.map;
                clusterer = resort.clusterer;
            }else{
                // большая
                resort.map_big_insert();
                map = resort.map_big;
                clusterer = resort.clusterer_big;

                after = resort.map_big_after_insert;
            }

            break;

        // карта на странице водоема
        case $('#water_map').length:
            if(!$('#map_big:visible').length){
                // маленькая карта
                if(result.length)
                    $('#water_map').show();
                else
                    $('#water_map').hide();

                water.map_insert();
                map = water.map;
                clusterer = water.clusterer;
            }else{
                // большая
                water.map_big_insert();
                map = water.map_big;
                clusterer = water.clusterer_big;

                after = water.map_big_after_insert;
            }

            break;
        // карта на странице поиска
        case $('#type_view_1').length:
            if(Object.keys(result).length)
                $('.empty', bases_search.$results).hide();
            else
                $('.empty', bases_search.$results).show();

            bases_search.map_insert();
            map = bases_search.map;
            clusterer = bases_search.clusterer;

            break;
        // карта на странице базы
        case $('#map_big').length:
            base.map_big_insert();
            map = base.map_big;
            clusterer = base.clusterer_big;

            after = base.map_big_after_insert;
            break;

        // карта на странице личного кабинета "избранные базы"
        case $('#folder_map').length:
            faforite_folder.map_insert();
            map = faforite_folder.map;
            clusterer = faforite_folder.clusterer;
            break;
        default:
            return;
    }

    $('#type_view_0').hide();
    $('#type_view_1').show();

    /**
     * Данные передаются вторым параметром в конструктор метки, опции - третьим.
     * @see https://api.yandex.ru/maps/doc/jsapi/2.1/ref/reference/Placemark.xml#constructor-summary
     */
    let placemarks = [];
    $.map(result, function(base, index){
        let points = [base.N, base.E];
        let placemark = new ymaps.Placemark(points, bases_search.map_genPlacemarkData(base), bases_search.map_genPlacemarkOptions(base));

        bases_search.map_genPlacemarkEvents(placemark, base); // добавить необходимые соыбтия к метке на карте

        placemarks.push(placemark);
    });

    clusterer.removeAll();
    if(!placemarks.length) return;
    clusterer.add(placemarks);
    if(auto_zoom){
        setTimeout(function(){
            map.setBounds(clusterer.getBounds(), {checkZoomRange: true, zoomMargin: 30}).then(function(){
                if(map.getZoom() > 11) map.setZoom(11);
                after();
            });
        }, 200);
    }

    // закрываем все balloon при клике на карту
    map.events.add('click', function(){
        map.balloon.close();
    });
};

bases_search.map_genPlacemarkData = function(base_data){
    /* Task #3992 - start */

    base_data.main_image = base_data.main_image || base_data.image || '';

    var type_name;
    if (typeof base_data.type_name === 'object') {
        type_name = base_data.type_name.ru;
    } else {
        type_name = base_data.type_name;
    }

    var contentBody = '<a href="' + base_data.link + '" target="_blank">' +
        '<span class="image" style="background-image:url(/images/bases/' + base_data.id + '/thumbs/' + base_data.main_image + '.jpg);">' +
        '<span class="price" style="display:none;"><small>от </small>' +
        '<span class="number_format">...</span> ' +
        '<small class="suffix">' + base_data.price_suffix + '</small>' +
        '</span>' +
        '</span>' +
        '</a>',
        hintContent = '<div class="map_hint">' +
            '<div class="type">' + type_name + '</div>' +
            '<div class="name">' + base_data.name + '</div>' +
            '<hr>' +
            '<div class="address">' + base_data.region + (base_data.city ? ', ' + base_data.city : '') + '</div>' +
            '</div>',
        arrow_prev = '<span class="map_popup_gallery_prev icon-chevron-left"></span>',
        arrow_next = '<span class="map_popup_gallery_next icon-chevron-right"></span>';

    contentBody = arrow_prev + contentBody + arrow_next;

    /* Task #3992 - end */

    var contentFooter = '<div class="type">' + type_name + '</div>';
    contentFooter += '<div class="name">' + base_data.name + '</div><hr>';
    contentFooter += '<div class="address">' + base_data.region + (base_data.city ? ', ' + base_data.city : '') + '</div>';

    return {
        balloonContentBody: contentBody,
        balloonContentFooter: contentFooter,
        clusterCaption: base_data.name,
        hintContent: hintContent
    };
};

bases_search.map_genPlacemarkOptions = function(base_data){
    // активная база на карте (открыта страницы этой базы)
    var zIndex = 200;
    var custom_current = false;
    var iconImageHref = '/images/template/map_point.png';
    var custom_iconImageHref_hover = '/images/template/map_point_a.png';
    var iconImageSize = [21, 32];
    var iconImageOffset = [-10, -32];
    if(window.base && base_data.N == base.N && base_data.E == base.E){
        zIndex = 600;
        custom_current = true;
        iconImageHref = '/images/template/map_point_cur.png';
        custom_iconImageHref_hover = '/images/template/map_point_cur_a.png';
        iconImageSize = [120, 60];
        iconImageOffset = [-60, -32];
    }

    return {
        //preset:'islands#darkGreenDotIcon',
        zIndex: zIndex,
        custom_current: custom_current,
        iconLayout: 'default#image',
        iconImageHref: iconImageHref,
        custom_iconImageHref: iconImageHref,
        custom_iconImageHref_hover: custom_iconImageHref_hover,
        iconImageSize: iconImageSize,
        iconImageOffset: iconImageOffset,
        balloonPanelMaxMapArea: 0 // Запретим замену обычного балуна на балун-панель.
    };
};

bases_search.map_genPlacemarkEvents = function(placemark, base){
    var opened = false;

    placemark.events
    .add('mouseenter', function(e){
        // Ссылку на объект, вызвавший событие, можно получить из поля 'target'.
        e.get('target').options.set('iconImageHref', placemark.options.get('custom_iconImageHref_hover'));
    })
    .add('mouseleave', function(e){
        if(opened) return;
        e.get('target').options.set('iconImageHref', placemark.options.get('custom_iconImageHref'));
    });

    placemark.events.add('balloonopen', function(){
        opened = true;
        placemark.options.set('iconImageHref', placemark.options.get('custom_iconImageHref_hover'));

        // подгрузить цену
        var action = bases_search.get_form_action() + '&id=' + base.id;
        var get_params = action.replace(/^.*?\?/, '');
        get_params += '&getFormat=json';

        var balloonContentBody = placemark.properties.get('balloonContentBody');

        mo.get(function(result){

            var gallery_html = "", i = 1;

            if(result.gallery !== undefined){
                while(result.gallery[i] !== undefined){
                    gallery_html = gallery_html + '<span class="gallery" style="background-image:url(/images/bases/' + result.id + '/thumbs/' + result.gallery[i].md5 + '.jpg);"></span>';
                    i++;
                }
            }

            // var room_first = result.rooms[Object.keys(result.rooms)[0]];
            // balloonContentBody = balloonContentBody.replace(/<span class="number_format">\.{3}/, '<span class="number_format">'+room_first.price_min);
            balloonContentBody = balloonContentBody.replace(/<span class="number_format">\.{3}/, '<span class="number_format">' + result.price_average_min);
            if(result.price_average_min > 0) balloonContentBody = balloonContentBody.replace('<span class="price" style="display:none;">', '<span class="price">');
            placemark.properties.set('balloonContentBody', balloonContentBody + gallery_html);

        }, 'bases', 'search_by_id&' + get_params);
    });

    placemark.events.add('balloonclose', function(){
        opened = false;
        placemark.options.set('iconImageHref', placemark.options.get('custom_iconImageHref'));
    });
};